import SimpleSchema from 'simpl-schema'

export default {
  _id: {
    type: String,
    visibility: false
  },
  name: {
    label: 'Nombre',
    type: String
  },
  imageUp: {
    label: 'Activo <strong style="font-size: 14px;">(64x64px)</strong>',
    type: SimpleSchema.Any,
    optional: true,
    image: true,
    width: 64,
    height: 64,
  },
  imageDown: {
    label: 'Inactivo <strong style="font-size: 14px;">(64x64px)</strong>',
    type: SimpleSchema.Any,
    optional: true,
    image: true,
    width: 64,
    height: 64,
  },
  imageAlert: {
    label: 'Alertado <strong style="font-size: 14px;">(64x64px)</strong>',
    type: SimpleSchema.Any,
    optional: true,
    image: true,
    width: 64,
    height: 64,
  },
  imageReported: {
    label: 'Reportado <strong style="font-size: 14px;">(64x64px)</strong>',
    type: SimpleSchema.Any,
    optional: true,
    image: true,
    width: 64,
    height: 64,
  },
  // attributes: {
  //   label: 'Atributos',
  //   type: Object,
  //   optional: true,
  //   attributes: true
  // }
};
